<template>
    <component :is="currentComponent" />
</template>

<script>
import Video from "@/pages/Video";
import Plug from "@/pages/Plug";

export default {
name: "TimeBasedRouter",
data() {
    return {
        currentComponent: Video,
        intervalId: null,
        // Configurazione: data e orario di inizio e fine
        // Formato: "YYYY-MM-DD HH:MM" (24 ore)
        startDateTime: "2026-03-16 14:30",
        endDateTime: "2026-03-19 19:30",
    };
},
created() {
    this.updateComponent();
    this.intervalId = setInterval(() => {
        this.updateComponent();
    }, 30*1e3);
},
beforeDestroy() {
    if (this.intervalId) {
        clearInterval(this.intervalId);
    }
},
methods: {
    /**
     * Verifica se la data/ora corrente è nell'intervallo configurato
     * @returns {boolean} true se siamo nell'intervallo, false altrimenti
     */
    isPlugTime() {
        const now = new Date();
        const start = this.parseDateTime(this.startDateTime);
        const end = this.parseDateTime(this.endDateTime);
        const isInRange = now >= start && now <= end;
        
        return isInRange;
    },
    
    /**
     * Converte una stringa "YYYY-MM-DD HH:MM" in un oggetto Date
     * @param {string} dateTimeString - Stringa nel formato "YYYY-MM-DD HH:MM"
     * @returns {Date} Oggetto Date corrispondente
     */
    parseDateTime(dateTimeString) {
        const [datePart, timePart] = dateTimeString.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hours, minutes] = timePart.split(":").map(Number);
        
        return new Date(year, month - 1, day, hours, minutes, 0, 0);
    },
    
    updateComponent() {
        this.currentComponent = this.isPlugTime() ? Plug : Video;
    }
}
};
</script>